import { getBearerToken } from '@/context/TrackOticAuthContext';
const API_BASE = process.env.REACT_APP_BACKEND_URL;

async function req(path, options = {}) {
  const token = getBearerToken();
  const res = await fetch(`${API_BASE}/api/reports${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try { const j = await res.json(); detail = typeof j.detail === 'string' ? j.detail : JSON.stringify(j.detail); } catch { /* noop */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res;
}

export const repGet = (path) => req(path).then(r => r.json());
export const repPost = (path, body) => req(path, { method: 'POST', body: JSON.stringify(body || {}) }).then(r => r.json());
export const repPut = (path, body) => req(path, { method: 'PUT', body: JSON.stringify(body || {}) }).then(r => r.json());
export const repPatch = (path, body) => req(path, { method: 'PATCH', body: JSON.stringify(body || {}) }).then(r => r.json());
export const repDelete = (path) => req(path, { method: 'DELETE' });
export const repGetBlob = (path) => req(path).then(r => r.blob());
